import React, { useState } from 'react';

/** "Delete group", confirmed inline. `onDelete()` resolves when done. */
const DeleteGroupButton = ({ groupName, onDelete, busy }) => {
  const [confirming, setConfirming] = useState(false);

  if (!confirming) {
    return (
      <button type="button" className="td-btn td-btn--danger" disabled={busy} onClick={() => setConfirming(true)}>
        Delete group
      </button>
    );
  }

  return (
    <div className="td-confirm" role="alertdialog" aria-label={`Delete ${groupName}?`}>
      <span>Delete “{groupName}”? The students stay in the school.</span>
      <button type="button" className="td-btn td-btn--danger" disabled={busy} onClick={onDelete}>
        {busy ? 'Deleting…' : 'Delete'}
      </button>
      <button type="button" className="td-btn" disabled={busy} onClick={() => setConfirming(false)}>Cancel</button>
    </div>
  );
};

export default DeleteGroupButton;
